export default __webpack_public_path__ + "static/media/Downcast.cf74ac41.svg";